 <template>
  <div class="projectPage">
    <van-search
      v-model="searchKeyword"
      class="searchBox"
      id="searchHeight"
      placeholder="请输入项目名称"
      show-action
      shape="round">
      <div slot="action" @click="onSearch">搜索</div>
    </van-search>
    <div class="list-content" id="list-content">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
      >
        <van-radio-group v-model="radio">
          <van-cell-group class="baseNone baseSalary">
            <van-cell
              :title="`${projectItem.projectName}`"
              clickable
              v-for="projectItem in itemMainList"
              :key="projectItem.id"
              @click="selectitem(projectItem)"
            >
              <van-radio
                slot="right-icon"
                :name="`${projectItem.projectName}`"
              />
            </van-cell>
          </van-cell-group>
        </van-radio-group>
      </van-list>
    </div>
    <div class="roleBtn clearfix">
      <a href="javascript:void(0);" class="fl" @click="closeRetinuePicker"
        >取消</a
      >
      <a href="javascript:void(0);" class="fl" @click="saveRetinue">确认</a>
    </div>
  </div>
</template>
<script>
export default {
  name: "projectView",
  data() {
    return {
      radio: "", //选中的项目
      searchName: "",
      searchKeyword: "", //搜索的姓名人员
      total: "", //统计计算
      itemMainList: [],
      selecItemList: [],
      projectData: {},
      firstContact: [],
      itemId: "",
      contractAmount: "",
      projectCompany: "",
      Itempage: 0,
      pageSize: 1000,
      loading: false, //是否处于加载状态
      finished: false, //是否已加载完所有数据
      projectStatus: ["lx", "dj", "zc", "zf", "wj"],
      projectJoinType: "doing",
      specialType: "1",
      fundingType: "1",
      marketArchive: false,
      technologyArchive: false,
      clientType: "", //手机类型
    };
  },

  mounted() {
    this.specialType = this.$route.query.specialType || "1"; //判断普通报销与特殊属性
    this.fundingType = this.$route.query.fundingType || "1"; //判断普通付款与特殊付款
    this.getProjectList();
  },
  methods: {
    onSearch() {
      let _this = this;
      _this.searchName = _this.searchKeyword;
      _this.reloadPage();
    },
    getProjectList() {
      let _this = this;
      if (
        _this.Itempage != 0 &&
        _this.Itempage * _this.pageSize >= parseInt(_this.total)
      ) {
        return;
      }
      _this.Itempage += 1;

      if (this.specialType == "2" || this.fundingType == "2") {
        //特殊报销 管理付款  全部项目
        _this.$api.baseCommon.baseMsg.dictBox
          .projectSelectList(
            {
              pageNum: _this.Itempage,
              pageSize: _this.pageSize,
              projectName: _this.searchName,
            },
            _this.projectStatus
          )
          .then((res) => {
            if (res.code == "1" && res.data != null) {
              _this.total = parseInt(res.data.total);
              _this.selecItemList = res.data.list;
              _this.viewLists();
              // 加载状态结束
              this.loading = false;
              if (_this.Itempage * _this.pageSize >= _this.total) {
                _this.finished = true;
              } else {
                _this.getProjectList();
              }
            } else {
              // console.log(res.msg);
              _this.selecItemList = [];
            }
          })
          .catch(() => {
            this.finished = true;
          });
      } else {
        //一般报销 出差/一般付款   我参与的项目

        _this.$api.baseCommon.baseMsg.dictBox
          .myJoinProject({
            pageNum: _this.Itempage,
            pageSize: _this.pageSize,
            projectJoinType: _this.projectJoinType,
            projectName: _this.searchName,
          })
          .then((res) => {
            if (res.code == "1" && res.data != null) {
              _this.total = parseInt(res.data.total);
              _this.selecItemList = res.data.list;
              _this.viewLists();
              // 加载状态结束
              this.loading = false;
              if (_this.Itempage * _this.pageSize >= _this.total) {
                _this.finished = true;
              } else {
                _this.getProjectList();
              }
            } else {
              _this.selecItemList = [];
            }
          })
          .catch(() => {
            this.finished = true;
          });
      }
    },
    viewLists() {
      this.itemMainList = this.itemMainList.concat(this.selecItemList);
    },
    selectitem(item) {
      let _this = this;
      _this.radio = item.projectName;
      _this.itemId = item.id;
      _this.contractAmount = item.contractAmount;
      _this.projectCompany = item.projectCompany;
      _this.firstContact = item.firstContact ? item.firstContact : [];
      _this.marketArchive = item.marketArchive;
      _this.technologyArchive = item.technologyArchive;
    },
    closeRetinuePicker() {
      this.projectData = {};
      this.$emit("setItems", "");
    },
    saveRetinue() {
      let _this = this;
      _this.projectData.id = _this.itemId;
      _this.projectData.name = _this.radio;
      _this.projectData.contractAmount = _this.contractAmount;
      _this.projectData.projectCompany = _this.projectCompany;
      _this.projectData.marketArchive = _this.marketArchive;
      _this.projectData.technologyArchive = _this.technologyArchive;
      _this.projectData.firstContact = _this.firstContact
        ? _this.firstContact
        : [];

      this.$emit("setItems", _this.projectData);
      _this.projectData = new Object();
    },

    reloadPage() {
      this.Itempage = 0;
      this.loading = false; //是否处于加载状态
      this.finished = false; //是否已加载完所有数据
      this.itemMainList = [];
      this.getProjectList();
    },
    // onLoad() {
    //   // 异步更新数据
    //   setTimeout(() => {
    //     this.getProjectList();
    //   }, 300);
    // },
  },
};
</script>
<style lang="less" >
.projectPage {
  width: 100%;
  height: 100%;
  background-color: #fff;
  .searchBox {
    padding: 0 8px;
    margin-bottom: 10px;
  }

  .list-content {
    height: calc(100% - 95px);
    overflow-y: scroll;
    .list-item {
      .item {
        height: 45px;
      }
    }
  }
  .baseSalary {
    .van-cell__title {
      span {
        display: inline-block;
        width: 85%;
        overflow: hidden;
      }
    }
  }
  .roleBtn {
    z-index: 100000;
    position: fixed;
    width: 100%;
    font-size: 0.42667rem;
    text-align: center;
    color: #333;
    height: 45px;
    border-top: 1px solid #f6f6f6;
    bottom: 0;
    z-index: 999;
    background-color: #fff;
    a:first-child {
      color: rgb(235, 199, 155);
      border-right: 1px solid #f6f6f6;
    }
    a {
      display: inline-block;
      width: 50%;
      height: 100%;
      line-height: 45px;
      color: #07c160;
      font-size: 14px;
      box-sizing: border-box;
    }
  }
}
</style>